import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BOOK_PAGES } from "../data/bookData";

const preface = BOOK_PAGES[0];

export const Dedication = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="dedication" data-testid="dedication-section" className="relative px-6 py-24 sm:py-32">
      <div className="mx-auto max-w-2xl text-center">
        <p className="font-hand text-2xl text-[#C87D87]">before the first chapter…</p>
        <h2 className="mt-3 font-display text-2xl font-semibold sm:text-3xl lg:text-4xl">The Preface, Sealed Until You're Ready</h2>
      </div>

      <div className="mx-auto mt-14 max-w-2xl">
        <div data-testid="dedication-letter-card" className="paper-card deckle px-8 py-12 sm:px-14">
          {!open ? (
            <div className="flex flex-col items-center py-6 text-center">
              <button
                data-testid="wax-seal-unlock-btn"
                onClick={() => setOpen(true)}
                aria-label="Break the wax seal to read the letter"
                className="wax-seal flex h-20 w-20 items-center justify-center rounded-full"
              >
                <span className="font-display text-2xl font-bold text-[#FFFDF9]">T</span>
              </button>
              <p className="mt-6 text-sm text-[#4A2E35]/60">press the seal to open</p>
            </div>
          ) : (
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                className="space-y-5 text-left"
                data-testid="dedication-letter-body"
              >
                <p className="font-hand text-3xl text-[#C87D87]">the preface</p>
                {preface.text.split(/\n\s*\n/).map((para, i) => (
                  <p key={i} className="text-sm leading-relaxed sm:text-base">{para}</p>
                ))}
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      </div>
    </section>
  );
};
